import { Container, Graphics, Sprite, Text } from "pixi.js";
import { Character } from "./pixiApplication";

export class Inventory {
  caughtLad: Character | undefined;
  caughtLadSprite: Sprite | undefined;
  container: Container;
  empty: Text;

  constructor(
    { width, height }: { width: number; height: number },
    { blockWidth, blockHeight }: { blockWidth: number; blockHeight: number },
  ) {
    const inventory = new Container();
    inventory.x = width - blockWidth * 2;
    inventory.y = height - blockHeight * 2;
    inventory.zIndex = 10;

    const iWidth = blockWidth * 2;
    const iHeight = blockHeight * 2;
    const bg = new Graphics()
      .rect(0, 0, iWidth, iHeight)
      .fill("#FFFFCC")
      .stroke({ width: 3, color: "#000033" });

    this.empty = new Text({
      text: "EMPTY",
      style: {
        fill: "#000033",
        fontSize: 18,
        fontFamily: "VCR",
      },
      anchor: 0.5,
      position: { x: blockWidth, y: blockHeight },
    });

    inventory.addChild(bg);
    inventory.addChild(this.empty);

    this.container = inventory;
  }

  catch(lad: Character) {
    lad.catch();
    lad.position = { x: 1, y: 1 };
    this.caughtLad = lad;
    this.container.removeChild(this.empty);
    this.caughtLadSprite = new Sprite(this.caughtLad.sprite.texture);
    this.caughtLadSprite.anchor = { x: 0.5, y: 0.5 };
    this.caughtLadSprite.scale = this.container.width / 20;
    this.caughtLadSprite.position = {
      x: this.container.width / 2,
      y: this.container.height / 2,
    };
    this.caughtLadSprite.visible = true;
    this.container.addChild(this.caughtLadSprite);
  }

  release() {
    this.container.removeChild(this.caughtLadSprite);
    this.caughtLad = undefined;
    this.caughtLadSprite.destroy();
    this.caughtLadSprite = undefined;
    this.container.addChild(this.empty);
  }
}
